module.exports = function() {
  return new Worker(__webpack_public_path__ + "edbf18953df831659645.worker.js");
};